'use client'
import { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import ReactPlayer from 'react-player'

export default function VideoModal({ open, setOpen, videoUrl, index }) {
  const [playing, setPlaying] = useState(true)
  const handleClick = () => {
    setOpen(false)
    setPlaying(!playing)
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-zinc-800 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full  items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className=" 
                               p-6 bg-gradient-to-br from-zinc-950 to-neutral-950 
                                rounded-[10px] border border-zinc-900 flex-col"
              >
                <div className="flex flex-col">
                  <div className="flex justify-end">
                    <XMarkIcon
                      className="h-6 w-6 text-neutral-300 cursor-pointer"
                      onClick={handleClick}
                    />
                  </div>
                  <div className=" mt-4 w-full h-full">
                    {!videoUrl?.includes('drive.google.com') ? (
                      <ReactPlayer
                        url={videoUrl}
                        playing={playing}
                        className="player"
                        controls={false}
                        loop
                      />
                    ) : (
                      <iframe
                        width="100%"
                        height="100%"
                        allow="autoplay"
                        src={
                          videoUrl.endsWith('/')
                            ? `${videoUrl}preview`
                            : `${videoUrl}/preview`
                        }
                      ></iframe>
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
